var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input",attrs:{"label":_vm.label,"color":"green","type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }